import helpers from '../helpers';
import {Fancybox} from '@fancyapps/ui';

function init() {
	window.dataLayer = window.dataLayer || [];

	Fancybox.defaults.Hash = false;

	Fancybox.bind('[data-fancybox]', {
		animationEffect: 'zoom',
		on: {
			closing: () => {
				helpers.lockScroll(false, $('.fancybox__slide'));
			},
		},
		Carousel: {
			on: {
				init: (carousel) => {
					carousel.options.initialPage = carousel.options.slides[carousel.options.initialPage].order - 1;
					carousel.options.slides = carousel.options.slides.sort((a, b) => +a.order - +b.order);
				},
			},
		},
	});

	Fancybox.defaults.hash = false;

	helpers.$document
		.on('click', 'span.home-people__link', (e) => {
			let $this = $(e.currentTarget);
			let $name = $this.parent().find('.home-people__name').text();

			e.preventDefault();
			e.stopPropagation();

			helpers.lockScroll(true, $('.fancybox__slide'));

			window.dataLayer.push({
				event: 'click_text',
				eventCategory: 'click',
				eventAction: $name,
			});
		})
		.on('click', 'button.home-people__link', (e) => {
			let $this = $(e.currentTarget);
			let $name = $this.parent().find('.home-people__name').text();

			e.preventDefault();

			window.dataLayer.push({
				event: 'click_text',
				eventCategory: 'click',
				eventAction: $name,
			});

			$this.closest('.home-people__item')
				.toggleClass('is-active')
				.find('.home-people__biography')
				.slideToggle();
		});
}

export default {
	init,
};
